'use strict';

var React = require('react');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

const BaseTextCard = ({ headingTag, title, titleLink, titleClass, subtext, subtextLink, subtextClass, onTitleClick, onSubtextClick, }) => {
    const HeadingTag = headingTag;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        titleLink ? (React__default["default"].createElement("a", { className: "text-card__link", href: titleLink, onClick: onTitleClick },
            React__default["default"].createElement(HeadingTag, { className: titleClass }, title))) : (React__default["default"].createElement(HeadingTag, { className: titleClass }, title)),
        subtext &&
            (subtextLink ? (React__default["default"].createElement("a", { className: subtextClass, href: subtextLink, onClick: onSubtextClick }, subtext)) : (React__default["default"].createElement("div", { className: subtextClass }, subtext)))));
};
const TextCard = ({ numberOfLinesToTruncateSubtext = 2, numberOfLinesToTruncateTitle = 2, headingTag = 'h3', isHorizontal = false, metadata, subtext, subtextLink, title, titleLink, onTitleClick, onSubtextClick, }) => {
    const cardClass = classNames__default["default"]('text-card', {
        'text-card--horizontal': isHorizontal,
        'text-card__expanded': metadata,
    });
    const titleClass = classNames__default["default"]('text-card__title', {
        'first-clamp': !metadata && numberOfLinesToTruncateTitle === 1,
        'second-clamp': !metadata && numberOfLinesToTruncateTitle === 2,
        'third-clamp': metadata && !subtext,
        'text-card__title--link': titleLink,
    });
    const subtextClass = classNames__default["default"]('text-card__subtext', {
        'first-clamp': !metadata && numberOfLinesToTruncateSubtext === 1,
        'second-clamp': !metadata && numberOfLinesToTruncateSubtext === 2,
        'text-card__subtext--link': subtextLink,
    });
    return (React__default["default"].createElement("div", { className: cardClass },
        metadata && React__default["default"].createElement("span", { className: "text-card__metadata" }, metadata),
        metadata ? (React__default["default"].createElement("div", { className: classNames__default["default"]({ 'text-card__expanded-wrapper': subtext }) },
            React__default["default"].createElement("div", { className: classNames__default["default"]({ 'text-card__expanded-content': subtext }) },
                React__default["default"].createElement(BaseTextCard, { headingTag: headingTag, title: title, titleLink: titleLink, titleClass: titleClass, subtextClass: subtextClass, subtext: subtext, subtextLink: subtextLink, onTitleClick: onTitleClick, onSubtextClick: onSubtextClick })))) : (React__default["default"].createElement(BaseTextCard, { headingTag: headingTag, title: title, titleLink: titleLink, titleClass: titleClass, subtextClass: subtextClass, subtext: subtext, subtextLink: subtextLink, onTitleClick: onTitleClick, onSubtextClick: onSubtextClick }))));
};

module.exports = TextCard;
